import { render, staticRenderFns } from "./CardCircolareAutomatica.vue?vue&type=template&id=307beacd&"
import script from "./CardCircolareAutomatica.vue?vue&type=script&lang=js&"
export * from "./CardCircolareAutomatica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports